import { PostSortSchema, PostTypeSchema } from '@onesource/schemas';
import { z } from 'zod';

/**
 * URL search params for the community feed — search, filters and sort are
 * kept in the URL so filter state is shareable and survives reload.
 * Every param is optional; the default sort (recent_activity) is represented
 * by omitting `sort`.
 */
export const FeedSearchParamsSchema = z.object({
  q: z.string().optional().catch(undefined),
  types: z.array(PostTypeSchema).optional().catch(undefined),
  from: z.string().optional().catch(undefined),
  to: z.string().optional().catch(undefined),
  /** Mention user id (from GET /mention/users) — resolved server-side */
  by: z.string().optional().catch(undefined),
  /** Display name of the selected member, so the button label renders without a lookup */
  byName: z.string().optional().catch(undefined),
  /** Available-tag values (question tag id or subspace/lesson source id) — resolved server-side */
  tags: z.array(z.string()).optional().catch(undefined),
  /** Quick filter: only posts the current user has saved (bookmarked) */
  saved: z.boolean().optional().catch(undefined),
  /** Quick filter: only the current user's own posts */
  mine: z.boolean().optional().catch(undefined),
  sort: PostSortSchema.optional().catch(undefined),
});

export type TFeedSearchParams = z.infer<typeof FeedSearchParamsSchema>;

export const hasActiveFeedFilters = (params: TFeedSearchParams): boolean =>
  !!(
    params.q ||
    params.types?.length ||
    params.from ||
    params.to ||
    params.by ||
    params.tags?.length ||
    params.saved ||
    params.mine
  );
